import { useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { pageStyle } from '../../constants/print-page-style';

const PrintTab = ({ callback, printTabRef }: any) => {
    const handleAfterPrint = () => {
        callback(false);
    };

    const handlePrint = useReactToPrint({
        content: () => printTabRef.current,
        documentTitle: 'Patient Education',
        removeAfterPrint: true,
        onBeforeGetContent: function handleOnBeforeGetContent() {},
        onBeforePrint: function handleBeforePrint() {},
        onAfterPrint: handleAfterPrint,
        pageStyle,
    });

    useEffect(() => {
        if (printTabRef.current) {
            handlePrint();
        }
    }, [printTabRef.current]);

    return null;
};

export default PrintTab;
